import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../components/Button/Button'
import EditIcon from '../../../svg/EditIcon'
import clsx from 'clsx'
import { useNetworkStatus } from '../../../utils/networkStatus'
import ButtonWithTooltip from '../../../components/ButtonWithTooltip/ButtonWithTooltip'

const EditAction = ({ isEnabled, isValid, setEnabled: setEnabledCard }) => {
    const [enabled, setEnabled] = useState(isEnabled)
    const { isOffline } = useNetworkStatus()

    useEffect(() => {
        setEnabled(isEnabled)
    }, [isEnabled])

    useEffect(() => {
        setEnabledCard(enabled)
    }, [enabled])

    const toggleEnabled = () => {
        setEnabled(!enabled)
    }

    const renderContent = () => {
        return (
            <div
                className={clsx(
                    'h-10 max-h-full relative',
                    !enabled && 'flex items-center justify-end w-auto',
                    enabled && 'md:w-auto w-full',
                )}
            >
                {enabled ? (
                    <div className="md:w-auto w-full h-full flex flex-row items-center md:justify-end justify-between gap-x-2">
                        <Button
                            text="Cancel"
                            variant="tertiary"
                            onClick={toggleEnabled}
                            className="md:w-auto w-full flex-grow"
                        />
                        <Button
                            text="Save Changes"
                            variant="secondary"
                            type="submit"
                            className="md:w-auto w-full flex-grow"
                            disabled={!isValid}
                        />
                    </div>
                ) : (
                    <ButtonWithTooltip
                        variant="tertiary"
                        onClick={toggleEnabled}
                        className="rounded-lg p-0 w-10 h-10"
                        icon={
                            <div className="text-textDarkerGray stroke-current stroke-2 w-5 h-5">
                                <EditIcon />
                            </div>
                        }
                        disabled={isOffline}
                        isOffline={isOffline}
                        position="left"
                    />
                )}
            </div>
        )
    }

    return renderContent()
}

EditAction.propTypes = {
    isValid: PropTypes.bool,
    isEnabled: PropTypes.bool,
    setEnabled: PropTypes.func,
}

export default EditAction
